<template>
  <div class="title-box">
    <span class="title">{{ moduleData.title }}</span>
  </div>
  <ul :class="['col-form-item-ul', select ? `flex-col-${select}` : '']">
    <template v-for="(item, index) in moduleData.componentList" :key="index">
      <li
        v-if="item.show"
        class="col-item"
        :class="[item.layout ? `col-${item.layout.proportion}` : '']"
      >
        <span class="fieldName">
          <span class="required-icon">{{ item.renderConfig.required ? '*' : '' }}</span>
          <span>{{ item.columnInfo.name }}</span>
        </span>

        <el-form-item :key="item.columnInfo.id">
          <div class="val">
            <Render
              :sceneType="SceneTypeEnum.FLOW_DETAIL"
              :data="item"
              :fieldCode="item.fieldCode"
              :comp-name="item.renderConfig.compName"
              :renderConfig="item.renderConfig"
              :value="getValue(item, form)"
              :quoteMappingConfig="quoteMappingConfig"
              @changeValue="value => changeValue(value, item, form)"
              @refreshDataList="value => refreshDataList(value, item)"
              :isTxt="isText || item.isTxt"
              :positions="positions"
              :subFieldFormData="subFieldFormData"
            />
          </div>
        </el-form-item>
      </li>
    </template>
  </ul>
</template>
<script setup lang="ts">
import type { PropType } from 'vue'
import Render from '@/components/custom/form/components/render.vue'
import { formulaEmitter } from '@/utils/business/formulaEmitter'
import { computed } from 'vue'
import { dealFormValConfig, isMapping, isQuote } from '@/utils/preObjectManage/utils'
import { fieldTypeConfig } from '@/enums/preObjectManage'
import { SceneTypeEnum } from '@/enums/business'

const associaFormCondition = inject('associaFormCondition') as Recordable[]

const props = defineProps({
  select: {
    type: Number,
    default: 1
  },
  moduleData: {
    type: Object as PropType<Recordable>,
    default: () => {}
  },
  formData: {
    type: Object as PropType<Recordable>,
    default: () => {}
  },
  quoteMappingConfig: {
    type: Object as PropType<Recordable>,
    default: () => {}
  },
  positions: {
    type: Array as PropType<Recordable[]>,
    default: () => []
  },
  subFieldFormData: {
    type: Object as PropType<Recordable>,
    default: () => ({})
  }
})
const refreshVisible = inject('refreshVisible') as Fn
const emit = defineEmits(['changeValue'])
const form = computed(() => {
  return props.formData
})

watch(
  () => props.moduleData,
  val => {
    console.log(val?.componentList, '嘻嘻嘻')
  },
  { immediate: true }
)

const equationList = inject('equationList') as Recordable[]
// 获取值
function getValue(data: Recordable, form: Recordable) {
  const { code, fieldCode, fieldType } = data
  let customCode = code
  // 引用字段
  if (isQuote(fieldType)) {
    customCode = fieldTypeConfig.quote
  }
  // 映射字段
  if (isMapping(fieldType)) {
    customCode = fieldTypeConfig.mapping
  }
  const getValueFn = dealFormValConfig[customCode]
    ? dealFormValConfig[customCode].getValue
    : () => form[fieldCode] || ''
  if (data.name === '意向产品') {
    console.log(getValueFn(data, form), 'getValueFn(data, form)')
  }
  // 只要是数字，金额，百分比就去触发
  if (
    code === fieldTypeConfig.number ||
    code === fieldTypeConfig.money ||
    code === fieldTypeConfig.percentage
  ) {
    formulaEmitter(
      unref(equationList),
      data,
      getValueFn(data, form),
      props?.moduleData?.componentList
    )
  }
  return getValueFn(data, form)
}

// 修改表单的值
function changeValue(value: any, data: Recordable, form: Recordable) {
  const { code, fieldCode } = data
  const setValueFn = dealFormValConfig[code]
    ? dealFormValConfig[code].setValue
    : () => {
        form[fieldCode] = value
      }
  setValueFn(value, data, form)
  // 如果是单选下拉或者单选按钮
  if (code === fieldTypeConfig.radio || code === fieldTypeConfig.select) {
    refreshVisible(data, value)
  }
  emit('changeValue')

  if (unref(associaFormCondition)?.length) {
    unref(associaFormCondition).forEach(item => {
      const cur = item.columnSerials.find(serial => serial === data.fieldSerial)
      if (cur) {
        item.Emitter.emit('associaForm', item.moduleSerial)
      }
    })
  }
}

function refreshDataList(value: any, item: Recordable) {
  item.dataList = value
  item.renderConfig.dataList = value
}

const isText = ref(true)

onMounted(() => {
  setTimeout(() => {
    isText.value = false
  }, 1000)
})
</script>
<style lang="scss" scoped>
.title-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 32px;

  .title {
    font-size: 14px;
    color: #333333;
    font-weight: 700;
    display: inline-block;
    border-left: 3px solid #5687ff;
    padding-left: 9px;
  }
}

.col-form-item-ul {
  display: flex;
  flex-wrap: wrap;
  margin-top: 8px;
  > li {
    //border: 1px solid transparent;
    border-right: 1px solid #ebeef5;
    border-bottom: 1px solid #ebeef5;
  }
  &.flex-col-1 {
    li {
      width: 100%;
      &:nth-child(1) {
        border-top: 1px solid #ebeef5;
      }
    }
  }
  &.flex-col-2 {
    li {
      width: 50%;
      &:nth-child(-n + 2) {
        border-top: 1px solid #ebeef5;
      }
    }
  }
  &.flex-col-3 {
    li {
      width: 33.33%;
      &:nth-child(-n + 3) {
        border-top: 1px solid #ebeef5;
      }
    }
  }
  &.flex-col-4 {
    li {
      width: 25%;
      &:nth-child(-n + 4) {
        border-top: 1px solid #ebeef5;
      }
    }
  }

  .col-item {
    display: flex;
    .required-icon {
      color: #f56c6c;
    }
    .fieldName {
      font-size: 14px;
      color: #333;
      height: 100%;
      line-height: 20px;
      padding: 10px 0;
      display: flex;
      align-items: center;
      width: 100px;
      background-color: #f4f4f5;
      padding-left: 8px;
      flex-shrink: 0;
    }
    &.col-1 {
      width: 25%;
    }

    &.col-2 {
      width: 33.33%;
    }

    &.col-3 {
      width: 50%;
    }

    &.col-4 {
      width: 66.66%;
    }

    &.col-5 {
      width: 75%;
    }

    &.col-6 {
      width: 100%;
    }

    .val {
      flex: 1;
      display: flex;
      align-items: center;
      padding: 0 16px;
      font-size: 14px;
      color: #333333;
      word-break: break-all;
      overflow-y: auto;
    }
  }
}
</style>
